module.exports = __webpack_public_path__ + "static/media/logo_lianxiang.a4f92c8d.png";